import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

import { AppDispatch, RootState } from './configureStore';
import { getFVIPipingReportCoverData } from '../services/reportService';
import { ExxonMobilFVIPipingCoverData } from '../utils/models';
import { getCachedDataFromException } from '../utils/utilities';
import _ from 'lodash';

export interface CoverDataState {
	error: boolean;
	isLoading: boolean;
	isFVIPipingVisible: boolean;
	fviCoverData: ExxonMobilFVIPipingCoverData;
}

export const initialFVICoverData: ExxonMobilFVIPipingCoverData = {
	workOrderNumber: '',
	scopeOfWork: '',
	exxonMobilWorkProcedure: '',
	vtProcedure: '',
	ropeAccessCodeOfPractice: '',
	russelsmithProcedure: '',
	coverData: [],
};

const initialCoverDataState: CoverDataState = {
	error: false,
	isLoading: false,
	isFVIPipingVisible: false,
	fviCoverData: initialFVICoverData,
};

const slice = createSlice({
	name: 'coverData',
	initialState: initialCoverDataState,
	reducers: {
		setToggleVisible: (coverData, action) => {
			coverData.isFVIPipingVisible = action.payload;
		},
		setCoverDataSuccess: (coverData, action) => {
			coverData.isLoading = false;
			coverData.fviCoverData = action.payload;
		},
		setCoverDataRequested: (coverData) => {
			coverData.isLoading = true;
		},
		setCoverDataFailed: (coverData) => {
			coverData.isLoading = false;
			coverData.error = true;
		},
	},
});

const formatCoverData = (coverData: ExxonMobilFVIPipingCoverData) => {
	const trimmedCoverData = _.omit(coverData, [
		'_id',
		'__v',
		'id',
		'createdAt',
		'updatedAt',
	]) as ExxonMobilFVIPipingCoverData;

	const trimmedCoverDataItems = trimmedCoverData.coverData.map((i) =>
		_.omit(i, ['_id'])
	);

	const newCoverData = {
		...trimmedCoverData,
		coverData: trimmedCoverDataItems,
	};

	return newCoverData;
};

export const loadPipingCoverData =
	(id: string) => async (dispatch: AppDispatch) => {
		try {
			dispatch(slice.actions.setCoverDataRequested());

			const result = await getFVIPipingReportCoverData(id);
			dispatch(slice.actions.setCoverDataSuccess(formatCoverData(result.data)));
		} catch (ex) {
			const cachedData = getCachedDataFromException(ex);
			if (!cachedData) return dispatch(slice.actions.setCoverDataFailed());

			dispatch(slice.actions.setCoverDataSuccess(formatCoverData(cachedData)));
		}
	};

export const getCoverData = createSelector(
	(state: RootState) => state,
	(state) => state.coverData
);

export const { setToggleVisible, setCoverDataRequested } = slice.actions;
export default slice.reducer;
